import { Fragment, useRef, useState, useEffect } from "react";
import {
  Autocomplete,
  Switch,
  Grid2 as Grid,
  FormControlLabel,
  TextField,
} from "@mui/material";
import BTDialogBox from "../../../components/BTDialgBox";
import BTInput from "../../../components/BTInput";
import BTButton from "../../../components/BTButton";
import secureLocalStorage from "react-secure-storage";
import authService from "../../../services/auth-service";
import { CircularProgress } from "@mui/material";
import { useNotification } from "../../../context";
import { Notifications } from "@mui/icons-material";
import { isEqual } from "lodash";
import { service_price_type } from "../../../dropdownData";
import { useDispatch } from "react-redux";
import { get, insert, update, remove } from "../../../store/labSlice";
const AddService = ({ open, setOpen }) => {
  const { addNotification } = useNotification();
  const dispatch = useDispatch();
  const { value, actionType } = open;
  const { u_id, admin_u_id, u_type } = secureLocalStorage.getItem("userdata");
  const initialState = {
    ser_name: null,
    ser_price_type: null,
    ser_code: null,
    ser_desc: null,
    ser_time: null,
    admin_u_id: u_type === 1 ? u_id : admin_u_id,
    ser_created_by: u_id,
    ser_updated_by: u_id,
  };
  const [formData, setFormData] = useState(
    actionType === 1 ? [initialState] : value
  );
  const [errors, setErrors] = useState({});
  const [loading, setLoading] = useState(false);
  const scrollRef = useRef(null);
  const validateForm = (records) => {
    const errors = {};
    if (!records || records.length === 0) {
      return errors;
    }
    records?.forEach((record, index) => {
      const { ser_code, ser_name, ser_price_type, ser_time } = record;
      const recordsErrors = {};
      const addError = (field, message) => (recordsErrors[field] = message);

      if (!ser_name?.trim()) {
        addError("ser_name", "Service Name is required");
      }
      if (!ser_code?.trim()) {
        addError("ser_code", "Service Code is required");
      }
      if (!ser_price_type) {
        addError("ser_price_type", "Service Price type is required");
      }
      if (!ser_time) {
        addError("ser_time", "Service Time is required");
      }
      if (Object.keys(recordsErrors).length > 0) {
        errors[index] = recordsErrors;
      }
    });
    return errors;
  };
  const handleClose = () => {
    setOpen(false);
    setFormData(initialState);
  };

  const submitService = async (e) => {
    e.preventDefault();
    const newErrors = validateForm(formData);
    setErrors(newErrors);
    if (Object.keys(newErrors).length === 0) {
      if (actionType === 2 && isEqual(formData, value)) {
        return addNotification({
          icon: <Notifications color="white" />,
          title: "Error!",
          message: "No changes to save",
          color: "error",
        });
      } else {
        try {
          setLoading(true);
          const isNewservice = actionType === 1;
          const response = isNewservice
            ? await authService.insert_service({
                attributes: { data: formData },
              })
            : await authService.update_service({
                attributes: { data: formData },
              });
          if (response?.status === 1) {
            isNewservice
              ? dispatch(
                  insert({
                    name: "services",
                    data: response?.data,
                    fetch: true,
                  })
                )
              : dispatch(
                  update({
                    name: "services",
                    key: "ser_id",
                    data: response?.data,
                    fetch: true,
                  })
                );
            addNotification({
              icon: <Notifications color="white" />,
              title: "Success!",
              message: response?.message,
              color: "success",
            });
            setLoading(false);
            handleClose();
          }
        } catch (error) {
          addNotification({
            icon: <Notifications color="white" />,
            title: "Error!",
            message: "Somthing Went Wrong!",
            color: "error",
          });
          setLoading(false);
        }
      }
    }
  };

  const handleChange = (index, e) => {
    const { name, value, type, checked } = e.target;
    const fieldValue = type === "checkbox" ? checked : value;
    setFormData((prev) => {
      const updatedRecords = [...prev];
      updatedRecords[index] = {
        ...updatedRecords[index],
        [name]: fieldValue,
      };
      return updatedRecords;
    });
    setErrors((prev) => {
      const newErrors = { ...prev };
      if (newErrors[index]?.[name]) {
        delete newErrors[index][name];
        if (Object.keys(newErrors[index]).length === 0) {
          delete newErrors[index];
        }
      }
      return newErrors;
    });
  };

  const handleAutocompleteChange = (index, name, value) => {
    const fieldValue = value?.value || "";
    setFormData((prev) => {
      const updatedRecords = [...prev];
      updatedRecords[index] = {
        ...updatedRecords[index],
        [name]: fieldValue,
      };
      return updatedRecords;
    });
    setErrors((prev) => {
      const newErrors = { ...prev };
      if (newErrors[index]?.[name]) {
        delete newErrors[index][name];
        if (Object.keys(newErrors[index]).length === 0) {
          delete newErrors[index];
        }
      }
      return newErrors;
    });
  };

  const handleSwitchChange = (name) => (e) => {
    setFormData((prev) => ({
      ...prev,
      [name]: e.target.checked ? 1 : 0,
    }));
  };

  const renderField = (field, index) => {
    const value = formData[index]?.[field.name];
    const error = errors[index]?.[field.name];
    switch (field.type) {
      case "select":
        return (
          <Autocomplete
            options={field?.options}
            value={field?.options.find((opt) => opt.value === value) || null}
            onChange={(_, value) =>
              handleAutocompleteChange(index, field.name, value)
            }
            renderInput={(params) => (
              <TextField
                {...params}
                label={field.label}
                variant="standard"
                fullWidth
                error={!!error}
                helperText={error}
                required={field?.required || false}
              />
            )}
          />
        );

      case "checkbox":
      case "switch":
        return (
          <FormControlLabel
            control={
              <Switch
                checked={Boolean(formData[field.name]) || false}
                onChange={handleSwitchChange(field.name)}
                color="primary"
              />
            }
            label={field.label}
            labelPlacement="start"
            sx={{
              justifyContent: "space-between",
              marginLeft: 0,
              marginRight: 0,
              width: "100%",
            }}
          />
        );

      default:
        return (
          <BTInput
            name={field.name}
            step={field?.step || ""}
            label={field.label}
            type={field.type || "text"}
            value={value || ""}
            onChange={(e) => handleChange(index, e)}
            inputProps={{ step: field?.step, min: field?.min }}
            variant="standard"
            required={field?.required || false}
            fullWidth
            error={!!error}
            helperText={error}
            {...field.props}
          />
        );
    }
  };

  const formFields = [
    {
      name: "ser_name",
      label: "Service Name",
      type: "text",
      gridSize: { xs: 12, md: 2 },
      required: true,
    },
    {
      name: "ser_price_type",
      label: "Service Price Type",
      type: "select",
      options: service_price_type,
      gridSize: { xs: 12, md: 2 },
      required: true,
    },
    {
      name: "ser_code",
      label: "Service Code",
      type: "text",
      gridSize: { xs: 12, md: 2 },
      required: true,
    },
    {
      name: "ser_time",
      label: "Service Time",
      type: "number",
      gridSize: { xs: 12, md: 2 },
      required: true,
    },
    {
      name: "ser_desc",
      label: "Description",
      type: "text",
      gridSize: { xs: 12, md: 2 },
    },
  ];
  const addFields = () => {
    setFormData((prev) => [...prev, initialState]);
  };

  const removeFields = (service) => {
    if (service?.ser_id) {
      const modiFiedData = formData?.map((item) => {
        if (item?.ser_id === service?.ser_id) {
          return { ...item, ser_deleted: item?.ser_deleted === 1 ? 0 : 1 };
        }
        return item;
      });
      setFormData(modiFiedData);
    } else {
      const filterData = formData?.filter((_, idx) => idx !== service);
      setFormData(filterData);
    }
  };
  useEffect(() => {
    if (scrollRef.current) {
      scrollRef.current.scrollTop = scrollRef.current.scrollHeight;
    }
  }, [formData]);
  return (
    <BTDialogBox
      open={Boolean(open)}
      fullWidth
      maxWidth="lg"
      ref={scrollRef}
      onSubmit={submitService}
      close={handleClose}
      title={actionType === 1 ? "Add service" : "Edit service"}
      buttons={[
        {
          name: "Cancel",
          color: "secondary",
          size: "small",
          onClick: handleClose,
        },
        {
          name: actionType === 1 ? "Submit" : "Edit",
          variant: "gradient",
          type: "submit",
          color: "dark",
          size: "small",
          loading: loading,
          loadingComponent: (
            <Fragment>
              <svg width={0} height={0}>
                <defs>
                  <linearGradient
                    id="my_gradient"
                    x1="0%"
                    y1="0%"
                    x2="0%"
                    y2="100%">
                    <stop offset="0%" stopColor="#e01cd5" />
                    <stop offset="100%" stopColor="#1CB5E0" />
                  </linearGradient>
                </defs>
              </svg>
              <CircularProgress
                size={22}
                sx={{
                  "svg circle": { stroke: "url(#my_gradient)" },
                }}
              />
            </Fragment>
          ),
          sx: { ml: 2, width: "80px" },
        },
      ]}>
      <Grid container spacing={1}>
        {formData?.map((item, index) => (
          <Grid container key={index} spacing={1} width={"100%"}>
            <Fragment>
              {formFields?.map((field) => (
                <Grid
                  size={{ ...field?.gridSize }}
                  key={`${index}-${field.name}`}
                  mt={1}>
                  {renderField(field, index)}
                </Grid>
              ))}
              <Grid
                size={{ xs: 12, md: 2 }}
                mt={2.5}
                gap={1}
                display={"flex"}
                flexDirection={"row"}>
                {index === formData?.length - 1 && (
                  <BTButton
                    color="dark"
                    variant={"gradient"}
                    disabled={formData?.length === 1}
                    size="small"
                    sx={{ width: { xs: "100%", md: "80px" }, height: "30px" }}
                    onClick={() => removeFields(item?.ser_id ? item : index)}>
                    {!item?.ser_deleted ? "Remove" : "Recover"}
                  </BTButton>
                )}
                <BTButton
                  color="dark"
                  variant={"gradient"}
                  size="small"
                  sx={{ width: { xs: "100%", md: "60px", height: "30px" } }}
                  onClick={() =>
                    index === formData?.length - 1
                      ? addFields()
                      : removeFields(item?.ser_id ? item : index)
                  }>
                  {index === formData?.length - 1
                    ? "Add"
                    : !item?.ser_deleted
                    ? "Remove"
                    : "Recover"}
                </BTButton>
              </Grid>
            </Fragment>
          </Grid>
        ))}
      </Grid>
    </BTDialogBox>
  );
};

export default AddService;
